export const pagamentoLoteStatusLabels = {
  identificado: 'Identificado',
  conciliacaoAutomatica: 'Conciliação automática',
  conciliacaoManual: 'Conciliação manual',
  conciliado: 'Conciliado',
  publicado: 'Publicado',
  nenhumaGuiaEncontrada: 'Nenhuma guia encontrada',
  conciliadoParcialmente: 'Conciliado parcialmente',
}
